import 'alpinejs';
import ScrollOut from 'scroll-out';

document.querySelector('form').addEventListener('submit', function (event) {
  event.preventDefault();
  const button = document.querySelector('form button[type=submit]');
  const feedback = document.querySelector('#feedback');

  const fakeEmail = document.querySelector('input[name=email]');
  const fakeWebsite = document.querySelector('input[name=website]');

  const name = document.querySelector('input[name=inputName]');
  const phone = document.querySelector('input[name=inputPhone]');
  const email = document.querySelector('input[name=inputEmail]');
  const message = document.querySelector('textarea[name=inputMessage]');

  feedback.classList.remove(
    'bg-red-500',
    'bg-green-600',
    'py-2',
    'px-3',
    'mt-4'
  );
  feedback.innerHTML = '';
  button.innerHTML = `<span class="mr-1">
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      class="animate-spin fill-current text-white"
    >
      <path
        d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      />
    </svg>
  </span> Enviando...`;

  const formData = new FormData(this);

  fetch('contacto.php', {
    method: 'post',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (!data.success) {
        if (data.errors.inputName) {
          name.classList.add('border-red-500');
        }
        if (data.errors.inputPhone) {
          phone.classList.add('border-red-500');
        }
        if (data.errors.inputEmail) {
          email.classList.add('border-red-500');
        }
        if (data.errors.inputMessage) {
          message.classList.add('border-red-500');
        }
        feedback.classList.add('bg-red-500', 'py-2', 'px-3', 'mt-4');
        feedback.innerHTML = 'Los campos marcados en rojo son obligatorios.';
      } else {
        Array.from(document.querySelectorAll('input, textarea')).map((el) =>
          el.classList.remove('border-red-500')
        );
        feedback.classList.remove('bg-red-500');
        feedback.classList.add('bg-green-600', 'py-2', 'px-3', 'mt-4');
        feedback.innerHTML = 'Su mensaje ha sido enviado. ¡Gracias!';
        document.querySelector('form').reset();
      }
      button.innerHTML = 'Enviar mensaje';
    })
    .catch((error) => {
      console.log(error);
      button.innerHTML = 'Enviar mensaje';
      Array.from(document.querySelectorAll('input')).map((el) =>
        el.classList.remove('border-red-500')
      );
      feedback.classList.remove('bg-green-600');
      feedback.classList.add('bg-red-500', 'py-2', 'px-3', 'mt-4');
      feedback.innerHTML =
        'Hay un problema con nuestro servicio. Favor de contactarnos por teléfono.';
    });
});

ScrollOut({
  /* options */
});

// Select all links with hashes
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
    });
  });
});
